import City from './city'
import { TravellerType } from './travellerType'
import { TravelWithType } from './travelWithType'

export default class DisplayUser {
  _id?: string
  circle_user_id?: string
  name: string
  bio?: string
  date_of_birth?: Date
  subtitle?: string
  large_avatar_url?: string
  small_avatar_url?: string
  hero_image_url?: string
  city?: City
  dream_destinations: City[] = []
  dream_destination_reason?: string
  traveller_types: TravellerType[] = []
  travel_with_types: TravelWithType[] = []
  points: number = 0
  is_influencer: boolean = false
  instagram_username?: string
  tiktok_username?: string
  youtube_username?: string
  substack_username?: string
  followers_count: number
  following_count: number
  referral_access_code?: string
  city_identifying_name?: string

  isPremiumMember: boolean = false
  profile_type?: string

  constructor(data: Record<string, unknown>) {
    this._id = data._id as string | undefined
    this.circle_user_id = data.circle_user_id as string | undefined
    this.name = (data.name as string) ?? 'Anonymous'
    this.bio = data.bio as string | undefined
    this.date_of_birth = data.date_of_birth
      ? new Date(data.date_of_birth as string)
      : new Date()
    this.subtitle = (data.subtitle as string) ?? ''
    this.large_avatar_url = data.large_avatar_url as string | undefined
    this.small_avatar_url = data.small_avatar_url as string | undefined
    this.hero_image_url = data.hero_image_url as string | undefined
    this.city = data.city as City | undefined
    this.dream_destinations = data.dream_destinations as City[] ?? []
    this.dream_destination_reason = data.dream_destination_reason as string | undefined
    this.traveller_types = (data.traveller_types as TravellerType[]) ?? []
    this.travel_with_types = (data.travel_with_types as TravelWithType[]) ?? []
    this.points = (data.points as number) ?? 0
    this.is_influencer = (data.is_influencer as boolean) ?? false
    this.instagram_username = data.instagram_username as string | undefined
    this.tiktok_username = data.tiktok_username as string | undefined
    this.youtube_username = data.youtube_username as string | undefined
    this.substack_username = data.substack_username as string | undefined
    this.referral_access_code = data.referral_access_code as string | undefined
    this.followers_count = (data.followers_count as number) ?? 0
    this.following_count = (data.following_count as number) ?? 0
    this.isPremiumMember = (data.isPremiumMember as boolean) ?? false
    this.profile_type = data.profile_type as string | undefined
  }
}
